export const serviceUrls = {
  validationAccountNumber: "Authentication/ValidationAccountNumber",
  validateAcctWithBvnNin: "Authentication/ValidateAccountWithBVNAndNIN",
  ValidationAccountNumberWithOTP:
    "Authentication/ValidationAccountNumberWithOTP",
  validateOtp: "Authentication/validateOTP",
  UploadFile: "Authentication/UploadFile",
  UpgradeSwiftToTier2: "SavingsAccount/UpgradeSwiftToTier2",
  ValidateIdentity: "Authentication/ValidateIdentity",
  BranchCodeList: "Enum/BranchCodeList",
  CurrentReferee: "CurrentAccount/CurrentReferee",
  DomiciliaryReferee: "DomiciliaryCurrent/DomiciliaryReferee",
};
